// Anonymous identifier: persisted in localStorage + sent with /api/convert
// so the backend can enforce "one conversion ever" for visitors without an
// account (layered with an HttpOnly cookie + IP/UA fingerprint server-side).
const KEY = "decal_anon_id";

export function getAnonId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : _fallbackUuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return _fallbackUuid();
  }
}

export function clearAnonId() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}

function _fallbackUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
